module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_1.82b3be2b.png";